// Mutation hook - oznaczenie Notify jako pierwszej wiadomosci watku.
// POST /api/ui/sales-crm/notify/{id}/mark-as-thread-opener
// Sprint 3 v4.1.

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IPostMarkAsThreadOpenerResponse } from 'api/types/notify';

export interface IUsePostMarkAsThreadOpenerParams {
  notifyId: number;
  dealId?: number;
  threadId?: number;
}

const postMarkAsThreadOpener = (
  params: IUsePostMarkAsThreadOpenerParams
): Promise<IPostMarkAsThreadOpenerResponse> =>
  axios.post(`/sales-crm/notify/${params.notifyId}/mark-as-thread-opener`);

export const usePostMarkAsThreadOpener = (
  options?: UseMutationOptions<
    IPostMarkAsThreadOpenerResponse,
    IError,
    IUsePostMarkAsThreadOpenerParams
  >
) => {
  const queryClient = useQueryClient();
  return useMutation<
    IPostMarkAsThreadOpenerResponse,
    IError,
    IUsePostMarkAsThreadOpenerParams
  >(postMarkAsThreadOpener, {
    ...options,
    onSuccess: async (data, variables, context) => {
      if (variables.dealId) {
        await queryClient.invalidateQueries(['sales-crm-notify', 'by-deal', variables.dealId]);
      }
      if (variables.threadId) {
        await queryClient.invalidateQueries(['sales-crm-notify', 'by-thread', variables.threadId]);
      }
      options?.onSuccess?.(data, variables, context);
    }
  });
};
